module.exports = __webpack_public_path__ + "img/e.622be6e9.jpg";